import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { StepButton } from '../../shared-components';
import {
  customLabelStyles,
  StyledFormTextInput,
  StyledFormFormattedInput,
  FieldWrapper,
  QuestionText,
  TextInputField,
} from './styles';

type FreeTextInputProps = {
  question: string;
  name: string;
  placeholder?: string;
};

type SubmitButtonProps = {
  children: React.ReactNode;
};

// Wrapper components that apply custom label styles
export const FormTextInput = (props: any): JSX.Element => (
  <StyledFormTextInput {...props} labelstyles={customLabelStyles} />
);

export const FormFormattedInput = (props: any): JSX.Element => (
  <StyledFormFormattedInput {...props} labelstyles={customLabelStyles} />
);

// Free text input component with error handling
export const FreeTextInput = ({ question, name, placeholder = '' }: FreeTextInputProps): JSX.Element => {
  const { control, formState } = useFormContext();
  const hasError = !!formState.errors[name];

  return (
    <FieldWrapper>
      <QuestionText>{question}</QuestionText>
      <Controller
        name={name}
        control={control}
        defaultValue=''
        render={({ value, onChange }) => (
          <TextInputField
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type='text'
            hasError={hasError}
          />
        )}
      />
    </FieldWrapper>
  );
};

// Submit button with form validation
export const SubmitButton = ({ children }: SubmitButtonProps): JSX.Element => {
  const { formState } = useFormContext();
  const hasErrors = Object.keys(formState.errors).length > 0;

  return (
    <StepButton type='submit' disabled={hasErrors}>
      {children}
    </StepButton>
  );
};
